export { UpdateRequestChannel as Channel } from "types/gql-types";
import {
  WaitlistUpdateQuery_interestList_scheduledUpdate_requested as Requested,
  UpdateRequest_updateRequest_interests as InterestType,
  UpdateRequest_updateRequest as UpdateRequestType,
} from "types/gql-types";

// TS weirdly handles interfaces reexport thus redefining them as types
export type UpdateRequest = UpdateRequestType;
export type Interest = InterestType;

interface ScheduledUpdate {
  enabled: boolean;
  begins: string;
  ends: string;
  requested: Requested;
}

export interface Address {
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
}

export interface InterestList {
  id: string;
  email: string | null;
  name: string | null;
  type: "property";
  scheduledUpdate: ScheduledUpdate;
  address: {
    state: string | null;
    zip: string | null;
  } | null;
}
